import React, { useState } from 'react';
import { useNavigate, Navigate, Link } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { isSupabaseConfigured } from '../lib/supabaseClient';
import './LoginPage.css';

export default function LoginPage() {
  const { signIn, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Already signed in? Go straight to the console.
  if (user) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    const { error: err } = await signIn(email.trim(), password);
    setBusy(false);
    if (err) {
      setError(err.message || 'Could not sign in. Check your email and password.');
      return;
    }
    navigate('/admin', { replace: true });
  };

  return (
    <div className="admin-root login-page">
      <div className="login-card">
        <div className="login-brand">
          <span className="login-mark">MC</span>
          <h2>Staff Console</h2>
          <p className="login-sub">Sign in to view and route incoming calls.</p>
        </div>

        {!isSupabaseConfigured && (
          <div className="login-warning">
            Backend not configured yet. Add your Supabase keys in Netlify to enable sign-in.
          </div>
        )}

        <form onSubmit={onSubmit} className="login-form">
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              className="input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button className="btn btn-primary login-submit" type="submit" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <Link to="/" className="login-back">← Back to mc-movers.com</Link>
      </div>
    </div>
  );
}
